import clsx from "clsx";

type FocusRingProps = {
  /** Use the inverted (light-on-dark) border color. Default: false. */
  inverted?: boolean;
  /** Draw the stroke inside the parent (DS spec) for parents that clip overflow. */
  inside?: boolean;
};

/**
 * Focus ring, absolutely positioned outside the parent element's bounds, per
 * design spec. The parent element must set `group relative` (or `group`
 * plus its own positioning) for this to align correctly.
 *
 * Visible when the parent matches `:focus-visible`, and also when the user
 * is keyboard-tabbing (`html.user-is-tabbing` from `keyboardModality`) and
 * the parent is focused — same modality split FormField uses for inputs.
 */
export const FocusRing = ({
  inverted = false,
  inside = false,
}: FocusRingProps) => (
  <span
    className={clsx(
      "pointer-events-none absolute rounded-lg border-2 border-solid opacity-0 group-focus-visible:opacity-100 group-keyboard-focus:opacity-100",
      inside ? "inset-0" : "-inset-1",
      inverted ? "border-border-primary-inverse" : "border-border-primary",
    )}
    aria-hidden="true"
  />
);
